import * as React from 'react';
import ReactDom from 'react-dom';
import {get, set, merge, omit} from 'lodash';

import {useWithDataSource} from '@forms/Utils/Hooks';
import {send} from '@forms/Utils';
import Client from './Client';
import DEFAULT_PROPS from './Client/defaultProps';
import {GroupedTripsCollection, GroupToursRFQFormData} from './Client/definitions';

const hashToValues = () => {
	try {
		const hash = window.location.hash.substr(1) || '';

		if (!hash) {
			return {};
		}

		const [destinationValues, ...trips] = decodeURIComponent(escape(window.atob(hash))).split(',trip=');
		const destinations = destinationValues.split('=')[1].split(',');

		const groupedTrips: GroupedTripsCollection[] = destinations.map((name: string) => ({
			name,
			trips
		}));

		return set({}, 'quoteRequest.groupedTrips', groupedTrips);
	} catch(e) {}

	return {};
}

// Props, injected by dataset.
type GroupToursRFQForm = {
	component: string;
	csrfToken: string;
	labelUri: string;
	nodeAggregateIdentifier: string;
	redirectUri: string;
	rfqUri: string;
	tripUri: string;
	schoolUri: string;
	captchaIsActive: string;
	captchaSitekey: string;
}

export default ($el: HTMLElement) => {
	const $node = $el.querySelector('[data-select="SchoolTripsRfqForm"]');

	if (!$node) {
		return null;
	}

	// Get injected config by dataset.
	const CONFIG = {...$el.dataset} as GroupToursRFQForm;
	const $disclaimer = $el.querySelector('[data-select="disclaimer"]') as HTMLElement;

	// Get default + injected props
	const defaultValues = merge({},
		DEFAULT_PROPS,
		hashToValues()
	);

	const thanks = () => window.location.href = CONFIG.redirectUri;

	// Form API
	const submit = (data: GroupToursRFQFormData) => {
		// Extend selected School (from Excel) with ID
		const schoolId = get(data, 'hidden.school', '');
        const schoolName = get(data, 'participant.name', '');

        set(data, 'participant.name', `${schoolName} (CTS-ID: ${schoolId ? schoolId : 'leer'})`);

		send({
			uri: CONFIG.rfqUri,
			csrfToken: CONFIG.csrfToken,
			node: CONFIG.nodeAggregateIdentifier,
			data: {
				...omit(data, ['hidden']),
			},
			onSuccess: thanks,
			onFail: () => {}
		});
	}

	const withLabel = () => useWithDataSource({
		uri: CONFIG.labelUri
	});


	const withTrips = () => useWithDataSource({
		uri: CONFIG.tripUri
	});

	type InstitutionRequestData = {
		postalCodeQuery: string;
	}
	const withInstitutions = (data?: InstitutionRequestData) => useWithDataSource({
		uri: CONFIG.schoolUri,
		data,
		onRequest: true,
	});

	ReactDom.render(
		<Client {...{submit, withLabel, withTrips, withInstitutions, $disclaimer, defaultValues}}
			captchaIsActive={CONFIG.captchaIsActive === "1"}
			captchaSitekey={CONFIG.captchaSitekey}
		/>,
		$node
	);
}
